import {
	Button,
	Divider,
	Heading,
	useDisclosure,
	Modal,
	ModalBody,
	ModalContent,
	ModalHeader,
	ModalOverlay,
} from "@chakra-ui/react";
import clsx from "clsx";
import { Edit2, ShieldCheck } from "lucide-react";
import React from "react";
import { PortfolioEducation } from "../../types";
import { EducationLevel } from "../../__generated__/graphql";
import { EducationEditor } from "./education-editor";

interface EducationProps
	extends React.DetailedHTMLProps<
		React.HTMLAttributes<HTMLDivElement>,
	HTMLDivElement
	> {
	item: PortfolioEducation;
	editable?: boolean;
	onSaved?: () => void;
}

const educationLevelsMap = {
	[EducationLevel.Jssce]: "Junior Secondary School Certificate",
	[EducationLevel.Kcse]: "Kenya Certificate of Secondary Education",
	[EducationLevel.Ssce]: "Senior School Certificate",
	[EducationLevel.Nabteb]:
		"National Business and Technical Examination Board Certificate",
	[EducationLevel.Ond]: "Ordinary National Diploma",
	[EducationLevel.Hnd]: "Higher National Diploma",
	[EducationLevel.Bachelors]: "Bachelor's Degree",
	[EducationLevel.Masters]: "Master's Degree",
	[EducationLevel.Doctorate]: "Doctorate Degree",
};

export function EducationItem({
	item,
	className,
	editable,
	onSaved,
}: EducationProps) {
	const { isOpen, onOpen, onClose } = useDisclosure();

	const { id, schoolName, fieldOfStudy, qualification, verified } = item;

	return (
		<>
			{!!id && (
				<Modal
					isOpen={isOpen}
					onClose={onClose}
					isCentered
					closeOnOverlayClick
					size="lg"
				>
					<ModalOverlay />
					<ModalContent>
						<ModalHeader className="font-[AeonikPro] !text-2xl">
							Edit Education
						</ModalHeader>
						<Divider />
						<ModalBody>
							<EducationEditor
								item={{ ...item, id }}
								onClose={onClose}
								onSaved={onSaved}
							/>
						</ModalBody>
					</ModalContent>
				</Modal>
			)}
			<div
				className={clsx(" grid grid-cols-[1fr,auto] border-b py-4", className)}
			>
				<div className={clsx("flex flex-col gap-4 ")}>
					<div className="flex flex-col gap-2 items-start">
						<div className="flex flex-col lg:flex-row items-start lg:items-center  gap-1">
							<Heading as="h4" fontSize={18} className="font-medium m-0">
								{schoolName}
							</Heading>

							{verified && (
								<div className="flex  items-center gap-1">
									<ShieldCheck className="fill-brand-500 stroke-white" />
									<p>Verified</p>
								</div>
							)}
						</div>

						<p>{`${educationLevelsMap[qualification]}${
							fieldOfStudy ? `, ${fieldOfStudy}` : ""
						}
						`}</p>
					</div>
				</div>
				{!!id && editable && (
					<div className="flex flex-col items-end">
						<Button
							colorScheme="earthRed"
							variant="ghost"
							size="sm"
							px={0}
							leftIcon={<Edit2 className="w-4 h-4" />}
							onClick={onOpen}
						>
							Edit
						</Button>
					</div>
				)}
			</div>
		</>
	);
}
